<template>
  <div class="form-upload">
    <div class="row submit-bar">
      <h1>Egyedi feltöltés űrlapon keresztül</h1>
      <div class="buttons">
        <b-button 
          :disabled="!areAllFieldsValid" 
          size="lg" 
          variant="info" 
          class="submit-btn" 
          @click="submitForm(isTest=true)" >
            Teszt Beküldés 
        </b-button>
        <b-button 
          :disabled="!areAllFieldsValid" 
          size="lg" 
          variant="success" 
          class="submit-btn" 
          @click="submitForm(isTest=false)" >
            Beküldés 
        </b-button>
      </div>
    </div>
    <div class="legend">
      <span>Jelmagyarázat:</span>
      <div class="nhbr-invalid legend-item">Nem megfelelő bemenet</div>
      <div class="nhbr-recommended legend-item">Ajánlott mező</div>
    </div>
    <div>
      <b-card no-body :key="listUpdate">
        <b-tabs card v-model="tabIndex">
          <b-tab title="Betegellátó adatai">
            <InputGroupCard 
              title="Betegellátó adatai"
              :inputGroup="formInputsList['betegellato']"
              @onValidStateChanged="onValidStateChanged"
            />
          </b-tab>

          <b-tab title="Beteg adatai">
            <InputGroupCard 
              title="Beteg adatai"
              :inputGroup="formInputsList['beteg']"
              @onValidStateChanged="onValidStateChanged"
            />
          </b-tab>

          <b-tab title="Betegség alapadatok">
            <InputGroupCard 
              title="Betegség alapadatok"
              :inputGroup="formInputsList['betegseg_alap']"
              @onValidStateChanged="onValidStateChanged"
            />
          </b-tab>

          <b-tab title="Betegség részletek">
            <InputGroupCard 
              title="Kezelés"
              :inputGroup="formInputsList['betegseg_reszletek']['kezeles']"
              @onValidStateChanged="onValidStateChanged"
            />

            <InputGroupCard 
              title="Betegség részletei"
              :inputGroup="formInputsList['betegseg_reszletek']['reszletek']"
              @onValidStateChanged="onValidStateChanged"
            />

            <InputGroupCard 
              title="Labor részletei"
              :inputGroup="formInputsList['betegseg_reszletek']['labor']"
              @onValidStateChanged="onValidStateChanged"
            />
          </b-tab>

          <b-tab title="Betegség kimenetel adatai">
            <InputGroupCard 
              title="Betegség kimenetel adatai"
              :inputGroup="formInputsList['betegseg_kimenetel']"
              @onValidStateChanged="onValidStateChanged"
            />
          </b-tab>

          <b-tab title="További kezelés adatai">
            <InputGroupCard 
              title="További kezelés adatai"
              :inputGroup="formInputsList['tovabbi_kezeles']"
              @onValidStateChanged="onValidStateChanged"
            />
          </b-tab>
        </b-tabs>
      </b-card>
    </div>
  </div>
</template>

<script>
import InputGroupCard from '@/components/InputGroupCard.vue'
import formInputsList from '@/formInputs.js'
import { mapState } from 'vuex'
import { finalizeFormInputs } from '@/utils/dependencyUtil.js'
import { uploadFormInputs } from '@/services/backendService.js'

export default {
  name: 'form-upload',
  components: {
    InputGroupCard
  },
  data() {
    return {
      formInputsList: formInputsList,
      listUpdate: 0,
      tabIndex: 0,
      validationFields: {}
    }
  },
  computed: {
    ...mapState(['formInputs']),
    areAllFieldsValid() {
      return Object.keys(this.validationFields).every(item => this.validationFields[item])
    }
  },
  methods: {
    onValidStateChanged(event) {
      this.$set(this.validationFields, event.key, event.isValid)
    },
    submitForm(isTest=false) {
      const normalizedInputs = finalizeFormInputs(this.formInputs, this.formInputsList)
      
      uploadFormInputs(normalizedInputs, isTest).then(res => {
        if (res.status === 200) {
          alert('Sikeres feltöltés')
        } else {
          alert('Sikertelen feltöltés')
        }
      }).catch(error => {
        alert('Sikertelen feltöltés')
      })
    }
  }
}
</script>

<style scoped lang="scss">
/*** Component Style ***/
.form-upload {
  position: relative;

  .submit-bar {
    margin: 0 !important;
  }

  h1 {
    display: inline-block;
  }

  .buttons {
    margin-right: 48px;
    margin-left: auto;
    display: flex;
  }

  .submit-btn {
    position: relative;
    display: inline-block;
    margin-top: auto;
    margin-bottom: auto;
    margin-left: 24px;
  }

  .legend {
    text-align: left;
    padding-left: 32px;
    margin-bottom: 24px;

    .legend-item {
      width: fit-content;
      display: inline-block;
      margin-right: 16px;
      margin-left: 16px;
      padding: 5px;
      border: 1px solid #ced4da;
      border-radius: 0.25rem;
      font-size: 13px;
    }
  }
}

</style>
